import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { measure } from "@obs/tokens/index.stylex.ts";
import type { StyleXStyles } from "@stylexjs/stylex";
import * as stylex from "@stylexjs/stylex";

export type ItemWrapperProps = {
	sx?: StyleXStyles;
} & useRender.ComponentProps<"div">;

const styles = stylex.create({
	root: {
		paddingInline: measure.spacingHorizontalDefault,
		paddingBlock: measure.spacingVerticalDefault,
		gap: measure.spacingGapDefault,
		flexDirection: "row",
		textDecoration: "none",
		alignItems: "center",
		textAlign: "start",
		inlineSize: "100%",
		justifyContent: "stretch",
		border: "none",
		display: "flex",
	},
});

export const Wrapper = ({ render, sx, ...props }: ItemWrapperProps) => {
	return useRender({
		render,
		defaultTagName: "div",
		props: mergeProps<"div">(props, stylex.props(styles.root, sx)),
	});
};
